import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "./authentication.service";
import { IAbsenceForOthers, IAbsenceType, IAbsence, IResidualAbsence, IResidualAbsenceForm, IAbsenceForm } from "../models/absences";
import { ICurrentUser } from "../models/user-interface";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class AbsencesService {
  public typeList: IAbsenceType[];
  public absenceList: IAbsence[];
  public baseUrlTypeAbsence: string = "/absence-type";
  public baseUrlAbsence: string = "/absence";
  public typeAbsence: Array<string> = ["ferie", "permesso", "malattia", "infortunio", "maternità", "ore non retribuite", "altro"];
  public myAbsences: IAbsence[];
  public myLastFiveAbsence: IAbsence[];
  private currentUser: ICurrentUser;
  public residual_absences_keys: Array<string> = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "complete_name",
    "fiscal_code",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "type",
    "X",
    "Y",
    "Z",
    "AA",
    "AB",
    "quantity",
  ];

  constructor(
    private _httpClient: HttpClient,
    private _authenticationService: AuthenticationService,
  ) {
    this.currentUser = _authenticationService.getCurrentUser();
  }

  async getTypeList() {
    return this._httpClient
      .get(this.baseUrlTypeAbsence)
      .toPromise()
      .then((response: IAbsenceType[]) => {
        this.typeList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  //Get singola per il type di absence
  async getAbsenceType(id: number) {
    return this._httpClient.get<IAbsenceType>(this.baseUrlTypeAbsence + "/" + id).toPromise();
  }

  async createForOthers(data: IAbsenceForOthers) {
    if (data.to.includes("00:00:00")) {
      data.to = data.to.split(" ")[0] + " 23:59:59";
    }
    return this._httpClient.post("/absence-for-others", data).toPromise();
  }

  async createType(data: IAbsenceType) {
    return this._httpClient
      .post(this.baseUrlTypeAbsence, data)
      .toPromise()
      .then(async (response) => {
        await this.getTypeList();
        return response;
      });
  }

  async updateType(id: number, data: IAbsenceType) {
    return this._httpClient
      .put(this.baseUrlTypeAbsence + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getTypeList();
      });
  }

  async deleteType(id: number) {
    return this._httpClient
      .delete(this.baseUrlTypeAbsence + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getTypeList();
        return response;
      });
  }

  async sendAbsence(data: IAbsenceForm) {
    if (data.to.includes("00:00:00")) {
      data.to = data.to.split(" ")[0] + " 23:59:59";
    }

    return this._httpClient
      .post(this.baseUrlAbsence, data)
      .toPromise()
      .then(async (response) => {
        await this.getMineAbsences();
        return response;
      });
  }

  async updateAbsence(id: number, data: { has_file: number }) {
    return this._httpClient.put(this.baseUrlAbsence + "/" + id, data).toPromise();
  }

  async updateRequestedAbsence(actions: string, data: { absences: number[]; status_note?: string }) {
    return this._httpClient
      .post(this.baseUrlAbsence + "/" + actions, data)
      .toPromise()
      .then(async () => {
        await this.getAbsencesList();
      });
  }

  async getAbsencesList(month: number = 0, year: number = 0) {
    let url: string = this.baseUrlAbsence + "?";

    if (month > 0) {
      url += `month=${month}&`;
    }

    if (year > 0) {
      url += `year=${year}&`;
    }

    return this._httpClient
      .get(url)
      .toPromise()
      .then((response: IAbsence[]) => {
        this.absenceList = response;
        this.myAbsences = this.absenceList.filter((item: IAbsence) => {
          return item.user_hash === this.currentUser.hash;
        });
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async getMineAbsences() {
    return this._httpClient
      .get("/me/absence")
      .toPromise()
      .then((response: IAbsence[]) => {
        this.myAbsences = response;
        this.myLastFiveAbsence = this.myAbsences.sort((a: any, b: any) => (moment(b.from) > moment(a.from) ? 1 : -1)).slice(0, 5);
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async updateResidualAbsences(data: IResidualAbsenceForm | {}) {
    return this._httpClient.put("/users-absences", data).toPromise();
  }

  async getResidualAbsences() {
    return this._httpClient.get<IResidualAbsence[]>("/users-absences").toPromise();
  }

  async getAbsence(id: number) {
    return this._httpClient.get<IAbsence>("/absence/" + id).toPromise();
  }
}
